import {
  IsUUID,
  IsBoolean,
  IsEnum,
  IsInt,
  IsOptional,
  IsNotEmpty,
  Min,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ProficiencyLevel } from '../../../enums'

export class CreateProgramCompetencyDto {
  @ApiProperty({ description: 'Program version UUID' })
  @IsUUID()
  @IsNotEmpty()
  programVersionId!: string

  @ApiProperty({ description: 'Competency UUID' })
  @IsUUID()
  @IsNotEmpty()
  competencyId!: string

  @ApiPropertyOptional({ enum: ProficiencyLevel, default: 'CONSOLIDATE' })
  @IsEnum(ProficiencyLevel)
  @IsOptional()
  expectedLevel?: ProficiencyLevel

  @ApiPropertyOptional({
    description: 'Is this a key competency?',
    default: false,
  })
  @IsBoolean()
  @IsOptional()
  isKey?: boolean

  @ApiPropertyOptional({ description: 'Order in program' })
  @IsInt()
  @Min(0)
  @IsOptional()
  orderInProgram?: number
}
